export default [
  {
    path: '',
    name: 'banner list',
    component: () => import('@/views/app/banner/page-list.vue'),
    meta: { title: 'Daftar Banner' },
  },
  {
    path: 'tambah',
    name: 'banner create',
    component: () => import('@/views/app/banner/page-create.vue'),
    meta: { title: 'Tambah Banner' },
  },
  {
    path: ':id',
    name: 'banner edit',
    component: () => import('@/views/app/banner/page-edit.vue'),
    props: true,
    meta: { title: 'Edit Banner' },
  },
]
